import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {InvoiceData, InvoiceStatus, TabKeys} from '../types'
import { invoicesApi } from './api/invoicesApi'

interface InvoicesState {
	currentInvoice: InvoiceData | null
	currentTab: TabKeys
	incomingCurrentPage: number
	pendingCurrentPage: number
	processedCurrentPage: number
	pendingInvoiceId: number | null
	isInitialized: boolean
}

const initialState: InvoicesState = {
	currentInvoice: null,
	currentTab: TabKeys.incoming,
	incomingCurrentPage: 1,
	pendingCurrentPage: 1,
	processedCurrentPage: 1,
	pendingInvoiceId: null,
	isInitialized: false,
}

const invoicesSlice = createSlice({
	name: 'invoices',
	initialState,
	reducers: {
		setCurrentInvoice: (state, action: PayloadAction< InvoiceData | null>) => {
			state.currentInvoice = action.payload
		},
		setCurrentTab: (state, action: PayloadAction<TabKeys>) => {
			state.currentTab = action.payload
		},
		setIncomingCurrentPage: (state, action: PayloadAction<number>) => {
			state.incomingCurrentPage = action.payload
		},
		setPendingCurrentPage: (state, action: PayloadAction<number>) => {
			state.pendingCurrentPage = action.payload
		},
		setProcessedCurrentPage: (state, action: PayloadAction<number>) => {
			state.processedCurrentPage = action.payload
		},
		setInitialized: (state, action: PayloadAction<boolean>) => {
			state.isInitialized = action.payload
		},
	},
	extraReducers: (builder) => {
		builder
			.addMatcher(
				invoicesApi.endpoints.uploadInvoiceFile.matchFulfilled,
				(state, action) => {
					const invoice = action.payload?.data
					if(invoice){
						state.currentInvoice = invoice
						if(invoice.status === InvoiceStatus.ready_to_review){
							state.currentTab = TabKeys.incoming
						}
					}
				}
			)
			.addMatcher(
				invoicesApi.endpoints.postInvoice.matchFulfilled,
				(state, action) => {
					const updatedInvoice = action.payload.data
					if (updatedInvoice) {
						state.currentInvoice = updatedInvoice
						state.currentTab = TabKeys.processed
					}
				}
			)
			.addMatcher(
				invoicesApi.endpoints.getIncomingInvoices.matchFulfilled,
				(state, action) => {
					if (!state.isInitialized && action.payload.data.length > 0) {
						state.currentInvoice = action.payload.data[0]
						state.currentTab = TabKeys.incoming
						state.isInitialized = true
					}
				}
			)
			.addMatcher(
				invoicesApi.endpoints.getPendingInvoices.matchFulfilled,
				(state) => {
					if (!state.isInitialized && state.currentInvoice) {
						state.isInitialized = true
					}
				}
			)
			.addMatcher(
				invoicesApi.endpoints.getProcessedInvoices.matchFulfilled,
				(state) => {
					if (!state.isInitialized && state.currentInvoice) {
						state.isInitialized = true
					}
				}
			)
	},
})

export const {
	setCurrentInvoice,
	setCurrentTab,
	setIncomingCurrentPage,
	setPendingCurrentPage,
	setProcessedCurrentPage,
	setInitialized,
} = invoicesSlice.actions
export default invoicesSlice.reducer

